<template>
  <div>
    <SearchForm :class="{'mb-3': $mq === 'sm'}" @search="handleSearch" @reset="fetchData" />
    <b-row>
      <b-col v-if="!isFetching">
        <div class="d-flex justify-content-between mb-3">
          <b-btn
            variant="success"
            size="sm"
            @click="addInvoice">
            <i class="fa fa-plus" />&nbsp;
            New record
          </b-btn>
          <b-btn
            v-if="vehicle"
            size="sm"
            variant="warning"
            @click="handleDownloadAll">
            <i class="fa fa-download" />&nbsp;
            Download
          </b-btn>
        </div>
        <b-table-simple
          v-if="!isFetching && list.length"
          responsive>
          <b-thead head-variant="light">
            <b-th>Invoice No</b-th>
            <b-th class="cursor-pointer" @click="sort('dateService')">Date Service <i class="fa" :class="sortIcon('dateService')" /></b-th>
            <b-th class="cursor-pointer" @click="sort('workShop')">Workshop <i class="fa" :class="sortIcon('workShop')" /></b-th>
            <b-th>Mileage</b-th>
            <b-th />
          </b-thead>
          <b-tbody>
            <template v-for="invoice in list">
              <b-tr
                :key="invoice.id"
                class="cursor-pointer">
                <b-td @click="toggleInvoice(invoice)">{{ invoice.invoiceNo }}</b-td>
                <b-td @click="toggleInvoice(invoice)">{{ invoice.dateService | date('YYYY-MM-DD') }}</b-td>
                <b-td @click="toggleInvoice(invoice)">{{ invoice.workShop }}</b-td>
                <b-td @click="toggleInvoice(invoice)">{{ invoice.mileage }}</b-td>
                <b-td>
                  <b-btn
                    v-b-tooltip.hover
                    size="sm"
                    variant="success"
                    title="Edit invoice"
                    class="ml-2"
                    @click="editInvoice(vehicle, invoice)">
                    <i class="fa fa-pencil" />
                  </b-btn>
                  <b-btn
                    v-b-tooltip.hover
                    size="sm"
                    variant="danger"
                    title="Delete invoice"
                    class="ml-2"
                    @click="deleteInvoice(invoice)">
                    <i class="fa fa-close" />
                  </b-btn>
                </b-td>
              </b-tr>
              <b-tr
                v-if="collapsedInvoice.includes(invoice.id)"
                :key="`${invoice.id}-items`">
                <b-td colspan="4">
                  <b-table-simple small table-variant="secondary">
                    <b-thead head-variant="dark">
                      <b-th>Job Description</b-th>
                      <b-th>Work Carried Out</b-th>
                      <b-th>Quantity</b-th>
                      <b-th>Unit Price</b-th>
                      <b-th>Price</b-th>
                    </b-thead>
                    <b-tbody>
                      <b-tr
                        v-for="(invoiceItem, idx) in invoice.items"
                        :key="idx">
                        <b-td>{{ invoiceItem.jobDesc }}</b-td>
                        <b-td>{{ invoiceItem.workCarriedOut }}</b-td>
                        <b-td>{{ invoiceItem.quantity }}</b-td>
                        <b-td>{{ invoiceItem.unitPrice }}</b-td>
                        <b-td>{{ invoiceItem.price }}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-td>
              </b-tr>
            </template>
          </b-tbody>
        </b-table-simple>
        <b-alert v-if="!isFetching && !list.length" show variant="danger">
          No data found
        </b-alert>
        <!-- View modal -->
        <MRSModal 
          v-if="addModalVisibility"
          :is-submitting="isSubmitting"
          :done-submitting="doneSubmitting"
          :selected-invoice="selectedInvoice"
          :is-edit="isEditInvoice"
          modal-id="mrs-modal"
          @added="handleAddRecord" />
          
        <b-modal
          id="invoice-modal"
          v-if="selectedInvoice"
          :scrollable="true"
          title="Invoice Details"
          header-bg-variant="success"
          hide-footer
          size="md">
          <b-row>
            <b-col sm="6">
              <b-form-group label="Invoice No">
                <span class="font-weight-bold">{{ selectedInvoice.invoiceNo }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Date Service">
                <span class="font-weight-bold">{{ selectedInvoice.dateService | date('YYYY-MM-DD') }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Workshop">
                <span class="font-weight-bold">{{ selectedInvoice.workShop }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Mileage">
                <span class="font-weight-bold">{{ selectedInvoice.mileage }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table-simple>
            <b-thead head-variant="light">
              <b-th>Job Description</b-th>
              <b-th>Work Carried Out</b-th>
              <b-th>Price</b-th>
            </b-thead>
            <b-tbody>
              <b-tr v-for="(item, idx) in selectedInvoice.items" :key="idx">
                <b-td>{{ item.jobDesc }}</b-td>
                <b-td>{{ item.workCarriedOut }}</b-td>
                <b-td>{{ item.price }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import { toastr } from '@/services'
import transformJson from '@/utils/transformJson'
import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select'
import MRSModal from '@/views/mrs/MRSModal'
import InlineLabel from '@/components/InlineLabel'
import SearchForm from './SearchForm.vue'

export default {
  name: 'ServiceHistory',
  components: {
    MRSModal,
    DatePicker,
    InlineLabel,
    vSelect,
    SearchForm
  },
  data () {
    return {
      addModalVisibility: false,
      selectedItem: undefined,
      currentPage: 1,
      searchForm: {
        licensePlate: undefined,
        make: undefined,
        model: undefined
      },
      sortBy: '',
      sortOrder: '',
      make: undefined,
      model: undefined,
      isDownloading: false,
      vehicleForm: {},
      fields: [
        {
          key: 'dateService',
          sortable: true
        },
        {
          key: 'workShop',
          sortable: true
        },
        'invoiceNo',
        'mileage',
        'action'
      ],
      vehicle: {},
      collapsedItems: [],
      collapsedInvoice: [],
      selectedInvoice: {},
      isFetching: false,
      isSubmitting: false,
      doneSubmitting: false,
      visible: false,
      isExpandAll: false,
      isEditInvoice: false,
      list: [],
      maintenanceList: []
    }
  },
  computed: {
    vehicleFound() {
      return this.items.length > 0
    },
  },
  beforeDestroy() {
    this.$store.commit('mrs/RESET_FORM')
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      try {
        this.isFetching = true
        const resp = await this.$store.dispatch('mrs/fetchVehicle', { licensePlate: this.$route.query.licensePlate})
        const tmp = transformJson(resp.data.msgContent.data, true)
        this.isSubmitting = false
        this.isFetching = false
        if (!tmp.length) {
          toastr.error('No vehicle found.')
        } else {
          this.vehicle = tmp[0]
          if (!this.vehicle.vehicleRecordMr) {
            this.maintenanceList = []
          } else {
            this.maintenanceList = this.vehicle.vehicleRecordMr
            this.list = JSON.parse(JSON.stringify(this.maintenanceList))
          }
        }
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    toggleItem(licensePlate) {
      const idx = this.collapsedItems.indexOf(licensePlate)
      if (idx > -1) {
        this.collapsedItems.splice(idx, 1)
      } else {
        this.collapsedItems.push(licensePlate)
      }
    },
    async handleUpdate(item) {
      try {
        this.isSubmitting = true
        const { licensePlate, nextServiceDate, followupNextService, mileage, keyBatteryChangeDate, vehicleBatteryChangeDate } = item
        const payload = {
          vehicleNumber: licensePlate,
          nextServiceDate,
          followupNextService,
          mileage,
          keyBatteryChangeDate,
          vehicleBatteryChangeDate,
          vehicleRecordMR: []
        }
        await this.$store.dispatch('mrs/updateVehicle', [payload])
        this.isSubmitting = false
        toastr.success(false, 2000)
        this.handleSearch()
      } catch (err) {
        toastr.serverError()
      }
    },
    handleReset () {
      this.licensePlate = undefined
      this.make = undefined
      this.model = undefined
    },
    async handleAddRecord (item) {
      try {
        this.doneSubmitting = false
        this.isSubmitting = true
        const vehicleRecordTmp = this.vehicle.vehicleRecordMr ? [...this.vehicle.vehicleRecordMr] : []
        vehicleRecordTmp.push(item)
        const temp = {
          vehicle: {
            ...this.selectedItem,
            vehicleRecordMr: vehicleRecordTmp
          }
        }
        const { chasisNumber, makeModel, engineNumber, vehicleRecordMr, licensePlate, ...rest } = temp.vehicle
        const payload = {
          ...rest,
          vehicleRecordMR: [item],
          vehicleNumber: licensePlate,
        }
        await this.$store.dispatch('mrs/updateVehicle', [payload])
        this.isSubmitting = false
        this.doneSubmitting = true
        setTimeout(() => {
          this.$bvModal.hide('mrs-modal')
        }, 100)
        await this.fetchData()
        toastr.success(false, 2000)
      } catch (err) {
        console.log(err)
        toastr.serverError()
      }
    },
    addInvoice() {
      this.isEditInvoice = false
      this.selectedInvoice = null
      this.handleModalVisibility(this.vehicle)
    },
    handleModalVisibility (selectedItem, selectedInvoice = null) {
      this.selectedItem = selectedItem
      this.selectedInvoice = selectedInvoice
      this.addModalVisibility = true
      setTimeout(() => {
        this.$bvModal.show('mrs-modal')
      }, 100)
    },
    viewInvoice (item) {
      this.selectedInvoice = item
      this.$bvModal.show('invoice-modal')
    },
    async deleteInvoice (item) {
      try {
        await this.$store.dispatch('mrs/deleteInvoice', item)
        toastr.info('Invoice successfully deleted', false, 1000)
        await this.fetchData()
      } catch (err) {
        toastr.serverError()
      }
    },
    async editInvoice (record, invoiceItem) {
      try {
        this.isEditInvoice = true
        this.handleModalVisibility(record, invoiceItem)
      } catch (err) {
        console.log(err)
      }
    },
    handleDownloadAll () {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to 
      let arr = []
      if (this.maintenanceList.length) {
        this.vehicle.vehicleRecordMr.forEach((item) => {
          // eslint-disable-next-line no-unused-vars
          const { items, id, ...rest } = item
          let tmp = items.map((o) => ({
            licensePlate: this.vehicle.licensePlate,
            makeModel: this.vehicle.makeModel,
            chasisNumber: this.vehicle.chasisNumber,
            engineNumber: this.vehicle.engineNumber,
            nextServiceDate: this.$options.filters.date(this.vehicle.nextServiceDate, 'YYYY-MM-DD'),
            followupNextService: this.vehicle.followupNextService,
            ...({...rest, dateService: this.$options.filters.date(item.dateService, 'YYYY-MM-DD')}),
            ...o,
          }))
          arr = [...arr, ...tmp]
        })
        }
      arr = arr.flat()
      const headers = Object.keys(arr[0])
      let csvData = arr.map(row => headers.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      csvData.unshift(headers.join(','))
      csvData = csvData.join('\r\n')
      const filename = `MRS_ALL_INVOICE_${this.vehicle.licensePlate}_${this.$options.filters.date(new Date(), 'YYYY-MM-DD')}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
      } else {
        const link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', filename)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    toggleInvoice(invoice) {
      const idx = this.collapsedInvoice.indexOf(invoice.id)
      if (idx > -1) {
        this.collapsedInvoice.splice(idx, 1)
      } else {
        this.collapsedInvoice.push(invoice.id)
      }
    },
    expandAllInvoice (item) {
      item.isExpandAll = !item.isExpandAll
      if (item.isExpandAll) {
        item.vehicleRecordMr.forEach((invoice) => {
          this.collapsedInvoice.push(invoice.id)
        })
      } else {
        item.vehicleRecordMr.forEach((invoice) => {
          this.collapsedInvoice = this.collapsedInvoice.filter(o => o !== invoice.id)
        })
      }
    },
    handleSearch(params) {
      let tmp = JSON.parse(JSON.stringify(this.maintenanceList))
      Object.keys(params).forEach((key) => {
        if (key === 'dateService') {
          tmp = tmp.filter((item) => {
            return moment(item.dateService).isSameOrBefore(params.dateService[1])
              && moment(item.dateService).isSameOrAfter(params.dateService[0])
          })
        }
        if (key === 'workshop') {
          tmp = tmp.filter((item) => item.workShop.toLowerCase().includes(params.workshop.toLowerCase()))
        }
        if (key === 'commonItem') {
          tmp = tmp.filter((item) => {
            return item.items.length && item.items.some(({ workCarriedOut }) => workCarriedOut.toLowerCase() === params.commonItem.toLowerCase())
          })
        }
      })
      this.list = tmp
    },
    sortIcon(field) {
      if (this.sortBy === field) {
        return this.sortOrder === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc'
      }
      return 'fa-sort'
    },
    sort(field) {
      if (this.sortOrder === '' && this.sortBy !== field) {
        this.sortOrder = 'desc'
      } else {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      }
      this.sortBy = field
      const tmp = JSON.parse(JSON.stringify(this.list))
      this.list = tmp.sort((a, b) => {
        if (field === 'dateService') {
          return this.sortOrder === 'asc' ? moment(a.dateService) - moment(b.dateService)
            : moment(b.dateService) - moment(a.dateService)
        }
        return this.sortOrder === 'asc' ? a[field].localeCompare(b[field]) : b[field].localeCompare(a[field])
      })
    }
  }
}
</script>

<style lang="scss">
@import 'vue-select/src/scss/vue-select.scss';
</style>